// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: lab.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "taf";
function createBaseLab() {
    return { adb: undefined };
}
export const Lab = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.adb !== undefined) {
            Lab_Adb.encode(message.adb, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLab();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.adb = Lab_Adb.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { adb: isSet(object.adb) ? Lab_Adb.fromJSON(object.adb) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.adb !== undefined) {
            obj.adb = Lab_Adb.toJSON(message.adb);
        }
        return obj;
    },
    create(base) {
        return Lab.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLab();
        message.adb = (object.adb !== undefined && object.adb !== null) ? Lab_Adb.fromPartial(object.adb) : undefined;
        return message;
    },
};
function createBaseLab_Adb() {
    return { command: "" };
}
export const Lab_Adb = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLab_Adb();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { command: isSet(object.command) ? globalThis.String(object.command) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.command !== "") {
            obj.command = message.command;
        }
        return obj;
    },
    create(base) {
        return Lab_Adb.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLab_Adb();
        message.command = object.command ?? "";
        return message;
    },
};
function createBaseLab_LabInfo() {
    return { name: "", busy: false };
}
export const Lab_LabInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.busy !== false) {
            writer.uint32(16).bool(message.busy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLab_LabInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.busy = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            busy: isSet(object.busy) ? globalThis.Boolean(object.busy) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.busy !== false) {
            obj.busy = message.busy;
        }
        return obj;
    },
    create(base) {
        return Lab_LabInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLab_LabInfo();
        message.name = object.name ?? "";
        message.busy = object.busy ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
